import styled from "styled-components"
import { motion } from "framer-motion"
export const FeedBackFormContainer = styled.div`
  position: absolute;
  height: 100vh;
  width: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;

  .overlay {
    position: absolute;
    height: 100vh;
    width: 100%;
    z-index: 2500;
    background: #111;
    opacity: 0.9;
  }
`;

export const FormContainer = styled(motion.div)`
  background: #fff;
  position: relative;
  z-index: 3000;
  padding: 5%;
  margin: auto;
  .btnContainer {
    text-align: center;
    margin: 2rem 0;
    background: black;
    padding: 2rem;
  }

  .cancelButton {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    font-size: 1.5rem;
  }
`;